import { setupAccordion } from '../../src/js/utils/accordion';

const init = (): void => setupAccordion('.faq__item', '.faq__answer');

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
